import { __assign } from '../../../../../../../../../node_modules/tslib/tslib.es6.js';
import ZigButton from '../../../../../inputs/ZigButton/index.js';
import { ReactComponent as SvgResetIcon } from '../../../../../../assets/icons/reset-icon.svg.js';
import React__default from 'react';
import { useTranslation } from 'react-i18next';

var DropdownResetButton = function (props) {
    var t = useTranslation("zignaly-ui", { keyPrefix: "ZigFilters" }).t;
    return (React__default.createElement(ZigButton, __assign({ variant: "text" }, props, { sx: __assign({ textAlign: "center", p: "4px 9px 3px", fontSize: "14px", width: "100%", "> span": {
                top: "1px !important",
            } }, ((props === null || props === void 0 ? void 0 : props.sx) || {})), startIcon: React__default.createElement(SvgResetIcon, { style: { top: "1px !important" } }) }), t("reset")));
};

export { DropdownResetButton };
